if (!customElements.get("hotspot-tabs")) {
  class HotspotTabs extends Carousel {
    constructor() {
      super();
      this.hotspotClassName = this.carouselElement.dataset["hotspotclassname"] || "";
      if (this.hotspotClassName) {
        this.hotspotSynchronize();
      }
    }
    hotspotSynchronize() {
      this.hotspotElements = document.querySelectorAll(`.${this.hotspotClassName}`);
      this.hotspotElements[0].classList.add("active-slide");
      if (this.hotspotElements) {
        this.hotspotElements.forEach((element) =>
          element.addEventListener("click", () => {
            this.elementIndex = element.dataset.indexValue;
            if (this.elementIndex) {
              this.carousel.go(parseInt(this.elementIndex));
            }
          })
        );
      }
      this.carousel.on('moved', (newIndex) => {
        this.updateActiveSlide(newIndex);
      });
    }
    updateActiveSlide(index) {
      this.hotspotElements.forEach((el) => el.classList.remove("active-slide"));
      const activeElement = this.hotspotElements[index];
      if (activeElement) {
        activeElement.classList.add("active-slide");
      }
    }
  }
  customElements.define("hotspot-tabs", HotspotTabs);
}